<div class="chatbody" #chatContainer style="height: 400px; overflow-y: auto;">
  <div class="text-gray-500 my-5 w-100 text-center" *ngIf="messages.length == 0">
    No conversation yet
  </div>

  <div class="d-block mb-1" *ngFor="let msg of messages; let i = index">

    <!-- Date divider -->
    <div *ngIf="shouldShowDateDivider(i)" class="text-center my-3">
      <span class="badge bg-light text-dark">
        {{ getDateLabel(msg.sent_at) }}
      </span>
    </div>

    <!-- RECEIVER MESSAGE -->
    <div class="d-flex align-items-start gap-2 mb-2" *ngIf="receiveMsgData?.driverId == msg?.send_by">
      <div class="d-block">
        <div class="fs-7 py-2 px-4 rounded bg-light-info text-gray-900 fw-semibold mw-sm-250px text-start"
          style="word-break: break-word; white-space: pre-wrap;">
          {{ msg?.text }}
        </div>
        <span class="text-gray-500 fs-9 d-block mt-1">
          {{ formatTime(msg.sent_at) }}
        </span>
      </div>
    </div>

    <!-- SENDER MESSAGE -->
    <div class="d-flex align-items-end justify-content-end gap-2 mb-2" *ngIf="receiveMsgData?.userId == msg?.send_by">
      <div class="d-block text-end">
        <div class="chat-bubble sender-bubble bg-light-primary">
          <span class="message-text">{{ msg?.text }}</span>
        </div>
        <span class="message-meta text-gray-500 fs-9 d-flex align-items-center justify-content-end gap-1 mt-1">
          {{ formatTime(msg.sent_at) }}
          <span class="chat-ticks">
            <svg xmlns="http://www.w3.org/2000/svg" *ngIf="msg?.sent_at && msg?.unread === '1'" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="4 12 9 17 20 6"></polyline>
            </svg>
            <svg [class.tick-read]="msg?.unread === '0'" *ngIf="msg?.unread === '0'" viewBox="0 0 16 15" width="20" height="20">
              <path fill="currentColor"
                d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033L6.494 8.24a.365.365 0 0 0-.512.055l-.423.433a.364.364 0 0 0 .006.514l2.373 2.107c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" />
              <path fill="currentColor"
                d="M10.91 3.316l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" />
            </svg>
          </span>
        </span>
      </div>
    </div>

  </div>
</div>


<div class="chatFooter d-flex align-items-start gap-2 mt-5">
  <div class="w-100">
    <textarea class="d-block w-100 mh-50px flex-fill form-control" [(ngModel)]="sendMsg" maxlength="200"
      [placeholder]=" 'WRITE_MESSAGE_WITH_LIMIT' | translate " (keydown.enter)="onEnter($event)"></textarea>
    <div class="text-danger fs-8 mt-1" *ngIf="sendMsg && sendMsg.length >= 200">
      {{'MESSAGE_CANNOT_EXCEED_200_CHARACTERS' | translate}}
    </div>
  </div>
  <button class="btn btn-primary d-flex align-items-center justify-content-center w-40px h-100" (click)="sendMessage()"
    [disabled]="sendMsg && sendMsg.length > 200">
    <span class="d-flex flex-column w-25px text-white">
      <img class="w-25px text-white" src="../../assets/img/send.svg" alt="">
    </span>
  </button>
</div>